import React from 'react'
import PropTypes from 'prop-types'
import Validator from 'validatorjs'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import TextArea from 'components/TextArea'
import Button from 'components/Button'

import { CLAIM_NOTES } from 'constants'

import { statusChanged } from 'components/RequestStatus/actions'
import { notesFetched } from './actions'

export class NewNote extends BaseComponent {


  constructor() {
    super()
    this.state = {
      buttonProps: {
        disabled: true
      },
      formData: {
        note: ''
      }
    }

    this._bind('_handleSubmit', '_handleChange', '_validate')
  }

  _handleChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e.target.name, e.target.value)
  }

  _validate(name, value) {
    const validationRules = {
      note: 'string|required|min:5'
    }

    let formData = {
      ...this.state.formData,
      [name]: value
    }

    const validator = new Validator(formData, validationRules)

    this.setState({
      buttonProps: {
        disabled: !validator.passes()
      },
    })
  }

  _handleSubmit(e) {
    e.preventDefault()

    this.props.updateRequestStatus('progress', 'Creando nota...')
    request(CLAIM_NOTES(this.props.claimId), {
      method: 'POST',
      body: {
        content: this.state.formData.note
      }
    }).then((res) => {
      this.props.updateRequestStatus(res.status, res.message)
      this.props.notesFetched([res.note,...this.props.notes_list])
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'No pudimos crear la nota')
    })

    this.context.toggleModal(false)
  }

  render() {
    return (

      <div id="NewNote" className="NewNote Modal__content">
        <div className="NewNote__header d-flex justify-content-between align-items-center">
          <h1>Crear nota</h1>
          <span className="material-icons close-button" onClick={() => this.context.toggleModal(false)}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex NewNote__form">
          <p className="instructions">Las notas serán visibles únicamente por los usuarios administradores</p>
          <TextArea placeholder="Cuerpo de la nota, mínimo 100 caracteres."
                    label="Anotación:"
                    name="note"
                    value={this.state.formData.note}
                    onChange={this._handleChange}
                    />
          <div className="controls">
            <Button type="submit" buttonType="primary" size="big" {...this.state.buttonProps}>Crear anotación</Button>
          </div>
        </form>
      </div>
    )
  }
}

NewNote.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    notes_list: state.claimNotes.get('notes_list')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    notesFetched: (notification_list) => dispatch(notesFetched(notification_list))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewNote)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notes/NewNote.js